// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__2g6HK","item":"Navbar_item__1Qu4_"};